export default "__VITE_ASSET__499c34e8__"